import { useRef, useState } from 'react'
import styled from 'styled-components'
import noop from 'lodash/noop'

import { colors } from '@/styles'
import { Arrow } from '@/components/icons'
import { OptionList } from '@/components/option-list'
import { Label } from '@/components/text'

const Box = styled.div`
  border-radius: 6px;
  height: 60px;
  border: 1px solid ${colors.grey};
  padding: 0 10px;
  color: ${colors.grey16};
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  position: relative;
  background: ${colors.white};

  ${props =>
    props.minimal &&
    `
    border-radius: 0px;
    height: 16px;
    border: none;
    color: ${colors.regular};
    padding: 0;
    gap: 8px;
  `}
`

const Options = styled.div`
  position: absolute;
  max-height: ${props => (props.visible ? '9999px' : 0)};
  overflow: hidden;
  z-index: 100;
  margin-top: 8px;
  border: ${props => (props.visible ? `1.5px solid ${colors.grey88}` : 'none')};
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  background: ${colors.white};

  ${({ optionsStyle }) => optionsStyle}
`

const IconWrapper = styled.div`
  > svg {
    margin-bottom: 2px;
    transform: ${props => (props.visible ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: all 0.2s linear;
  }
`

const Dropdown = ({
  onChange = noop,
  value,
  display = 'Select',
  optionsStyle,
  minWidth,
  minimal,
  children
}) => {
  const [opened, setOpened] = useState(false)
  const ref = useRef()

  const onClickOutside = e => {
    if (ref.current.contains(e.target)) {
      return
    }
    close()
  }

  const toggle = () => {
    setOpened(curr => !curr)
  }

  const close = () => {
    setOpened(false)
  }

  const handleChange = newValue => {
    close()
    onChange(newValue)
  }

  return (
    <div ref={ref}>
      <Box onClick={toggle} minWidth={minWidth} minimal={minimal}>
        <Label
          fontSize={minimal ? '14px' : '18px'}
          type={minimal ? 'medium' : 'small'}
        >
          {display}
        </Label>
        <IconWrapper visible={opened}>
          <Arrow height={5} width={8} />
        </IconWrapper>
      </Box>
      <Options visible={opened} optionsStyle={optionsStyle}>
        <OptionList
          value={value}
          onChange={handleChange}
          clickOutsideCallback={onClickOutside}
          noBorderRadius
          vertical
        >
          {children}
        </OptionList>
      </Options>
    </div>
  )
}

export default Dropdown
